import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionConstants {
  static readonly canAccessConversationRecordings = 'Conversation.CanAccessConversationRecordings';
  static readonly conversationTranscriptEdit = 'Conversation.Transcript._Edit';

  static readonly PrivacyPermissionsGroup = 'Privacy';
  static readonly ViewAnonymizedUsers =
    PermissionConstants.PrivacyPermissionsGroup + '.ViewAnonymizedUsers';
  static readonly ViewEvaluatorInfo =
    PermissionConstants.PrivacyPermissionsGroup + '.ViewEvaluatorInfo';

  static readonly PremiumReports = 'PremiumReporting.PremiumReports';

  static readonly ConversationGroupName = 'Conversation';
  static readonly Translation = PermissionConstants.ConversationGroupName + '.CanManageTranslation';

  static readonly DefinitionManagementGroupName = 'DefinitionManagement';
  static readonly AttachedData =
    PermissionConstants.DefinitionManagementGroupName + '.AttachedData';
  static readonly Department = PermissionConstants.DefinitionManagementGroupName + '.Department';
  static readonly TagAndAutoTagging =
    PermissionConstants.DefinitionManagementGroupName + '.TagAndAutoTagging';
  static readonly Sources = PermissionConstants.DefinitionManagementGroupName + '.Sources';
  static readonly GenericLookup =
    PermissionConstants.DefinitionManagementGroupName + '.GenericLookup';
  static readonly Integration = PermissionConstants.DefinitionManagementGroupName + '.Integration';
  static readonly IgnoredWords =
    PermissionConstants.DefinitionManagementGroupName + '.IgnoredWords';
  static readonly ReasonPool = PermissionConstants.DefinitionManagementGroupName + '.ReasonPool';
  static readonly RootCause = PermissionConstants.DefinitionManagementGroupName + '.RootCause';

  static readonly AdministrationGroupName = 'Administration';
  static readonly PronunciationManagement =
    PermissionConstants.AdministrationGroupName + '.PronunciationManagement';
  static readonly LicenseManagement =
    PermissionConstants.AdministrationGroupName + '.LicenseManagement';
  static readonly CallRecorderManagement =
    PermissionConstants.AdministrationGroupName + '.CallRecorderManagement';
  static readonly ScreenRecorderManagement =
    PermissionConstants.AdministrationGroupName + '.ScreenRecorderManagement';
  static readonly SettingManagement =
    PermissionConstants.AdministrationGroupName + '.SettingManagement';
  static readonly InteractionManagementGroupName =
    PermissionConstants.AdministrationGroupName + '.InteractionManagement';
  static readonly InteractionManagement = PermissionConstants.InteractionManagementGroupName;
  static readonly InteractionManagementCreateEditUserGroup =
    PermissionConstants.InteractionManagementGroupName + '.CreateEditUserGroup';
  static readonly InteractionManagementDeactivateUserGroup =
    PermissionConstants.InteractionManagementGroupName + '.DeactivateUserGroup';
  static readonly InteractionManagementCreateEditInteraction =
    PermissionConstants.InteractionManagementGroupName + '.CreateEditInteraction';
  static readonly InteractionManagementDeleteInteraction =
    PermissionConstants.InteractionManagementGroupName + '.DeleteInteraction';

  static readonly CoachingAndTraining = 'CoachingAndTraining';
  static readonly EmailAlert = PermissionConstants.CoachingAndTraining + '.EmailAlert';

  static readonly RealTimeGroupName = 'RealTime';
  static readonly CanViewAgentLoginActivity =
    PermissionConstants.RealTimeGroupName + '.CanViewAgentLoginActivity';
}
